<div class="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-between" style="width: 100%">
  <span class="tw-text-sm tw-font-semibold tw-text-dt-text-headings tw-text-wrap tw-line-clamp-2">{{
    name
  }}</span>
  <div class="tw-flex tw-flex-col tw-items-end tw-justify-center tw-gap-0.5 tw-py-3">
    <span
      class="tw-font-D-DIN-PRO tw-font-medium tw-text-[16px] tw-text-dt-slate-12 tw-leading-tight"
      >{{ amount | number: "1.2-2" }}
      <span class="tw-font-sans tw-font-medium tw-text-[12px] tw-text-dt-slate-10">AUD</span></span
    >
    <span class="tw-text-[11px] tw-text-dt-slate-9 tw-leading-tight">/{{ interval }}</span>
  </div>
</div>
